import { render } from "./UserContactCard.vue?vue&type=template&id=f68965e0"
import script from "./UserContactCard.vue?vue&type=script&lang=js"
export * from "./UserContactCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__